import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export const setPromoCodeValue = async (promoCode: string) => {
  try {
    const callParams = await getCallParams("POST", { promoCode });
    const response = await makeCall(urls.setPromoCode, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
